import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  useBreakpointValue,
  useToast,
  Tooltip,
} from "@chakra-ui/react";
import { BsFillCheckSquareFill } from "react-icons/bs";
import { ImCheckboxUnchecked, ImWhatsapp } from "react-icons/im";
import { Header } from "../../components/Header";
import { Sidebar } from "../../components/Sidebar";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { toaster } from "rsuite";
import { api } from "../../services/api";
import { maskCPF } from "../../utils/mask";
import { format } from "date-fns";
import { Pagination } from "../../components/Pagination";

interface Notifications {
  _id: string;
  read: boolean;
  user: {
    name: string;
    cpfCnpj: string;
    mobile: string;
  };
  createdAt: Date;
}

interface Response {
  _id: string;
  user: {
    name: string;
    cpfCnpj: string;
  }[];
  read: boolean;
  createdAt: Date;
}

export default function Support() {
  const toast = useToast();
  const [list, setList] = useState<Notifications[]>([]);
  const [totalData, setTotalData] = useState(0);

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  const isMdVersion = useBreakpointValue({
    base: false,
    md: true,
  });

  useEffect(() => {
    loadNotificationsSupport();
  }, []);

  const loadNotificationsSupport = async (pageNumber: number = 1) => {
    try {
      const { data } = await api.get("/notifications", {
        params: {
          page: pageNumber,
          category: "support",
        },
      });

      const dataFormatted = data.data[0].data.map((item: Response) => ({
        ...item,
        user: { ...item.user[0], cpfCnpj: maskCPF(item.user[0].cpfCnpj) },
      }));

      setList(dataFormatted);
      setTotalData(data.pageInfo.count);
    } catch (error) {
      console.log(error);

      toast({
        title: "Erro ao carregar dados",
        status: "error",
        isClosable: true,
      });
    }
  };

  async function handleMarkNotification(request: Notifications) {
    try {
      await api.put(`/notifications/${request._id}`);

      const newData = list.map((i: Notifications, e: any) => {
        if (i._id === request._id) {
          return {
            ...i,
            read: !i.read,
          };
        }
        return i;
      });

      setList(newData);
    } catch (error) {
      toast({
        title: "Falha ao finalizar solicitação",
        status: "error",
        isClosable: true,
      });
    }
  }

  const handlePageChange = (pageNumber: number) => {
    loadNotificationsSupport(pageNumber);
  };

  return (
    <Flex direction="column" h="100vh" bg="bg">
      <Header />

      <Flex w="100%" maxWidth={1460} px={isMdVersion ? "10" : "3"}>
        <Sidebar />

        <Box overflowX="auto" flex="1" borderRadius={8} bg="gray" p="6">
          {isWideVersion && (
            <Flex mb="8" justify="space-between" align="center">
              <Heading fontSize="21" fontWeight="400" color="text">
                Solicitações de Suporte
              </Heading>
            </Flex>
          )}

          <Table colorScheme="whiteAlpha">
            <Thead>
              <Tr color="gray_light">
                <Th fontWeight="600" fontSize="13" px="1" py="3">
                  Usuário
                </Th>
                <Th fontWeight="600" fontSize="13" px="1" py="3">
                  CPF
                </Th>
                {isWideVersion && (
                  <Th fontWeight="600" fontSize="13" px="1" py="3">
                    Solicitado em
                  </Th>
                )}
                <Th fontWeight="600" fontSize="13" px="1" py="3">
                  Contato
                </Th>
                <Th width="8" px="1" py="3"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {list
                .sort((a, b) => {
                  return Number(a.read) - Number(b.read);
                })
                .map((item) => (
                  <Tr>
                    <Td px="1" py="3">
                      <Box>
                        <Text color="text">{item.user.name}</Text>
                      </Box>
                    </Td>
                    <Td px="1" py="3">
                      <Box>
                        <Text color="text">{item.user.cpfCnpj}</Text>
                      </Box>
                    </Td>
                    {isWideVersion && (
                      <Td color="white" px="1" py="3">
                        {format(
                          new Date(item.createdAt),
                          "dd/MM/yyyy HH:mm:ss"
                        )}
                      </Td>
                    )}
                    <Td px="1" py="3" color="white">
                      {item.user.mobile}
                    </Td>
                    <Td px="1" py="3">
                      <Tooltip label={item.read ? "Finalizada" : "Em espera"}>
                        <Button
                          as="a"
                          size="sm"
                          fontSize="sm"
                          cursor="pointer"
                          disabled={item.read}
                          onClick={() => handleMarkNotification(item)}
                        >
                          <Icon
                            as={
                              item.read
                                ? BsFillCheckSquareFill
                                : ImCheckboxUnchecked
                            }
                            color={item.read ? "green.400" : "red.400"}
                            fontSize="20"
                          />
                        </Button>
                      </Tooltip>
                    </Td>
                  </Tr>
                ))}
            </Tbody>
          </Table>
          <Pagination
            total={totalData}
            totalPerPage={10}
            onChange={handlePageChange}
          />
        </Box>
      </Flex>
    </Flex>
  );
}
